import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider, App as AntApp } from 'antd';
import frFR from 'antd/locale/fr_FR';
import dayjs from 'dayjs';
import 'dayjs/locale/fr-ca';

import { useAuthBootstrap } from './hooks/useAuth';
import useTenantStore from './stores/tenantStore';
import AppRouter from './router';
import AppErrorBoundary from './components/AppErrorBoundary';
import { APP_NAME } from './constants/appName';

dayjs.locale('fr-ca');
document.title = APP_NAME;

function AppContent(): React.ReactElement {
  // Boots Firebase auth listener → populates auth/permission/tenant stores
  useAuthBootstrap();

  const primaryColor = useTenantStore((s) => s.tenant.primary_color);

  return (
    <ConfigProvider
      locale={frFR}
      theme={{
        token: {
          colorPrimary: primaryColor,
          borderRadius: 6,
          fontFamily: "'Inter', 'Segoe UI', sans-serif",
        },
        components: {
          Layout: { siderBg: '#001529' },
          Menu: { darkItemBg: '#001529' },
        },
      }}
    >
      <AntApp>
        <AppErrorBoundary>
          <AppRouter />
        </AppErrorBoundary>
      </AntApp>
    </ConfigProvider>
  );
}

export default function App(): React.ReactElement {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}
